import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ITraining } from '../../models/training.interface';


@Injectable({
  providedIn: 'root'
})
export abstract class TrainingApiService {
  abstract getList(trainingType:string): Observable<ITraining[]>;
}
